"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HeaderContacts = void 0;
var react_1 = __importDefault(require("react"));
var HeaderContacts_module_scss_1 = __importDefault(require("./HeaderContacts.module.scss"));
var react_redux_1 = require("react-redux");
var selectors_1 = require("../../redux/selectors");
var modalSlice_1 = require("../../redux/slice/modalSlice");
var selectors_2 = require("../../redux/selectors");
var transformPhoneNumber_1 = require("../../helpers/transformPhoneNumber");
var HeaderContacts = function () {
    var dispatch = (0, react_redux_1.useDispatch)();
    var isMedium = (0, react_redux_1.useSelector)(selectors_1.mediaQuerySelector).isMedium;
    var contacts = (0, react_redux_1.useSelector)(selectors_2.contactsSelector).contacts;
    var isLoad = (0, react_redux_1.useSelector)(selectors_2.contactsSelector).stateLoad.isLoading;
    var phoneHandler = function () {
        if (isMedium)
            return;
        dispatch((0, modalSlice_1.openModal)('callback'));
    };
    return (react_1.default.createElement("ul", { className: HeaderContacts_module_scss_1.default.header_contacts },
        react_1.default.createElement("li", { className: HeaderContacts_module_scss_1.default.header_contacts__item }, "\u0441 09:00 \u0434\u043E 21:00 \u0435\u0436\u0435\u0434\u043D\u0435\u0432\u043D\u043E"),
        react_1.default.createElement("li", { className: HeaderContacts_module_scss_1.default.header_contacts__item }, contacts.auto_address),
        react_1.default.createElement("li", { className: "".concat(HeaderContacts_module_scss_1.default.header_contacts__item, " ").concat(HeaderContacts_module_scss_1.default.header_contacts__item_phone), onClick: phoneHandler }, isLoad ? ('...') : !isMedium ? ((0, transformPhoneNumber_1.transformPhoneNumber)(contacts.phone)) : (react_1.default.createElement("a", { href: "tel: +".concat(contacts.phone) }, "+7 (499) 288-76-10")))));
};
exports.HeaderContacts = HeaderContacts;
